import { Doctor } from "./doctor";
import { Patient } from "./patients";
import { Prescription } from "./prescription";
import { PrescriptionDetails } from "./prescriptionDetails";
import { UserAccount } from "./user-account";

export class PrescriptionPatientVM {
  Patient: Patient;
  Prescription: Prescription;
  PrescriptionDetails: Array<PrescriptionDetails>;
  Doctor: Doctor;
}
